
<div class="space-y-6">
    <!-- Top Action Bar -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
            <h1 class="text-2xl font-bold text-gray-800 flex items-center gap-3">
                <i class="fa-solid fa-users-gear text-emerald-600"></i>
                {{ 'backOffice.employeeHub.title' | translate }}
            </h1>
            <p class="text-gray-500 text-sm">จัดการข้อมูลบุคลากร สิทธิ์การใช้งาน และประวัติกิจกรรม</p>
        </div>
        <div class="flex gap-2 w-full md:w-auto">
             <button (click)="openInviteModal()" class="flex-1 md:flex-none bg-emerald-600 hover:bg-emerald-500 text-white px-5 py-2.5 rounded-xl font-bold transition-all shadow-lg flex items-center justify-center gap-2">
                <i class="fa-solid fa-user-plus"></i>
                <span>{{ 'backOffice.employeeHub.invite' | translate }}</span>
            </button>
        </div>
    </div>

    <!-- Filter & Search Panel -->
    <div class="bg-white p-4 rounded-2xl shadow-sm border border-slate-200 flex flex-col lg:flex-row gap-4 items-center">
        <!-- Search -->
        <div class="relative flex-grow w-full">
            <i class="fa-solid fa-search absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"></i>
            <input type="text" [(ngModel)]="searchTerm" placeholder="ค้นหาชื่อ หรืออีเมล..." 
                   class="w-full pl-11 pr-4 py-2.5 bg-slate-50 border-transparent rounded-xl focus:bg-white focus:ring-2 focus:ring-emerald-500 transition-all text-sm">
        </div>

        <!-- Role Filter -->
        <div class="flex items-center gap-2 w-full lg:w-auto">
            <span class="text-xs font-bold text-slate-400 uppercase whitespace-nowrap">ตำแหน่ง:</span>
            <select [(ngModel)]="roleFilter" class="w-full lg:w-40 bg-slate-50 border-transparent rounded-xl text-sm p-2 focus:ring-2 focus:ring-emerald-500">
                <option value="all">ทั้งหมด (All Roles)</option>
                <option value="owner">เจ้าของร้าน</option>
                <option value="admin">ผู้จัดการ</option>
                <option value="doctor">แพทย์</option>
                <option value="cashier">พนักงาน/เภสัชกร</option>
                <option value="accountant">บัญชี</option>
            </select>
        </div>

        <!-- Status Filter -->
        <div class="flex items-center gap-2 w-full lg:w-auto">
            <span class="text-xs font-bold text-slate-400 uppercase whitespace-nowrap">สถานะ:</span>
            <select [(ngModel)]="statusFilter" class="w-full lg:w-32 bg-slate-50 border-transparent rounded-xl text-sm p-2 focus:ring-2 focus:ring-emerald-500">
                <option value="all">ทั้งหมด</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
            </select>
        </div>
    </div>

    <!-- Main Table Container -->
    <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        @if (loadingState() === 'loading') {
            <div class="p-20 text-center text-slate-400"><i class="fa-solid fa-spinner animate-spin text-4xl mb-4 text-emerald-500"></i><p>กำลังโหลดข้อมูลพนักงาน...</p></div>
        } @else {
            <div class="overflow-x-auto">
                <table class="w-full text-left border-collapse">
                    <thead>
                        <tr class="bg-slate-50 border-b border-slate-200">
                            <th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">พนักงาน (Employee)</th>
                            <th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">ตำแหน่ง (Role)</th>
                            <th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">PIN</th>
                            <th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">สถานะ (Status)</th>
                            <th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider text-right">การจัดการ</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-100">
                        @for (user of paginatedUsers(); track user.uid) {
                            <tr class="hover:bg-slate-50/80 transition-colors group">
                                <td class="px-6 py-4">
                                    <div class="flex items-center gap-3">
                                        <div [class]="'w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-sm ' + getAvatarColor(user.role)">
                                            {{ getInitials(user.name) }}
                                        </div>
                                        <div>
                                            <div class="font-bold text-gray-800">{{ user.name }}</div>
                                            <div class="text-xs text-gray-500">{{ user.email }}</div>
                                        </div>
                                    </div>
                                </td>
                                <td class="px-6 py-4">
                                    <span class="px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border"
                                          [class.bg-purple-100]="user.role === 'admin' || user.role === 'owner'"
                                          [class.text-purple-700]="user.role === 'admin' || user.role === 'owner'"
                                          [class.border-purple-200]="user.role === 'admin' || user.role === 'owner'"
                                          [class.bg-blue-100]="user.role === 'doctor'"
                                          [class.text-blue-700]="user.role === 'doctor'"
                                          [class.border-blue-200]="user.role === 'doctor'"
                                          [class.bg-slate-100]="user.role === 'staff' || user.role === 'cashier'"
                                          [class.text-slate-700]="user.role === 'staff' || user.role === 'cashier'"
                                          [class.border-slate-200]="user.role === 'staff' || user.role === 'cashier'">
                                        {{ user.role }}
                                    </span>
                                </td>
                                <td class="px-6 py-4">
                                    <code class="bg-slate-100 px-2 py-1 rounded text-xs font-bold tracking-widest text-slate-600">
                                        {{ user.pin || '----' }}
                                    </code>
                                </td>
                                <td class="px-6 py-4">
                                    @if(user.status === 'active') {
                                        <div class="flex items-center gap-2 text-emerald-600 font-bold text-xs">
                                            <span class="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
                                            Active
                                        </div>
                                    } @else {
                                        <div class="flex items-center gap-2 text-slate-400 font-bold text-xs">
                                            <span class="w-2 h-2 rounded-full bg-slate-300"></span>
                                            Inactive
                                        </div>
                                    }
                                </td>
                                <td class="px-6 py-4 text-right space-x-1">
                                    @if(user.role === 'owner') {
                                        <span class="text-[10px] font-bold text-slate-300 italic uppercase">System Owner</span>
                                    } @else {
                                        <button (click)="openEditModal(user)" class="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all" title="แก้ไขข้อมูล">
                                            <i class="fa-solid fa-pen-to-square"></i>
                                        </button>
                                        <button (click)="deleteUser(user)" [disabled]="user.uid === currentUser()?.uid" class="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all disabled:opacity-20" title="ลบพนักงาน">
                                            <i class="fa-solid fa-trash-can"></i>
                                        </button>
                                    }
                                </td>
                            </tr>
                        } @empty {
                            <tr>
                                <td colspan="5" class="px-6 py-20 text-center text-slate-400">
                                    <div class="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <i class="fa-solid fa-user-slash text-2xl opacity-30"></i>
                                    </div>
                                    <p class="font-bold">ไม่พบรายชื่อพนักงานที่ตรงตามเงื่อนไข</p>
                                    <button (click)="searchTerm.set(''); roleFilter.set('all'); statusFilter.set('all')" class="mt-2 text-xs text-blue-600 hover:underline">ล้างการค้นหา</button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

            <!-- Table Footer / Pagination -->
            <div class="px-6 py-4 bg-slate-50 border-t border-slate-200 flex flex-col sm:flex-row justify-between items-center gap-4">
                <div class="text-xs font-bold text-slate-500 uppercase tracking-wider">
                    {{ pageInfoText() }}
                </div>
                
                @if (totalPages() > 1) {
                    <div class="flex items-center gap-1">
                        <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1" class="w-8 h-8 rounded-lg bg-white border border-slate-300 flex items-center justify-center text-slate-600 hover:bg-slate-100 disabled:opacity-30 transition-colors shadow-sm">
                            <i class="fa-solid fa-chevron-left text-xs"></i>
                        </button>
                        
                        <div class="flex items-center px-3 text-sm font-bold text-slate-700">
                             {{ currentPage() }} / {{ totalPages() }}
                        </div>

                        <button (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages()" class="w-8 h-8 rounded-lg bg-white border border-slate-300 flex items-center justify-center text-slate-600 hover:bg-slate-100 disabled:opacity-30 transition-colors shadow-sm">
                            <i class="fa-solid fa-chevron-right text-xs"></i>
                        </button>
                    </div>
                }
            </div>
        }
    </div>
</div>

<app-employee-form-modal
  [isOpen]="isUserModalOpen()"
  [user]="editingUser()"
  (closeModal)="handleCloseModal()"
  (saveUser)="handleSaveUser($event)">
</app-employee-form-modal>

<app-invite-employee-modal
  [isOpen]="isInviteModalOpen()"
  (closeModal)="handleCloseModal()">
</app-invite-employee-modal>

<!-- Confirmation Modal -->
<app-confirmation-modal
  [isOpen]="confirmModalState().isOpen"
  [title]="confirmModalState().title"
  [message]="confirmModalState().message"
  [confirmButtonText]="confirmModalState().confirmButtonText"
  [confirmButtonClass]="confirmModalState().confirmButtonClass"
  (confirm)="onConfirmAction()"
  (cancel)="closeConfirmModal()">
</app-confirmation-modal>
